module.exports = __webpack_public_path__ + "img/tango-logo-surface.846ee3de.svg";